export default "__VITE_ASSET__fgA0esNl__"